import compose from '../fp/compose';
import Cache from './Cache';
import jsonCache from './jsonCache';
import provideStorage from './provideStorage';

var LocalStorageCache = compose(jsonCache(), provideStorage(localStorage))(Cache);

export default LocalStorageCache;


// WEBPACK FOOTER //
// ./node_modules/lyjs/es/cache/LocalStorageCache.js